import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import CollaborationInsuranceBlockData from 'Models/Content/CollaborationInsuranceBlockData';
import MainCollaborationInsurance from './MainCollaborationInsurance';

export default class CollaborationInsuranceBlock extends EpiComponent<CollaborationInsuranceBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    return <MainCollaborationInsurance iContent={this.props.data} context={this.getContext()} />;
  }
}

